<div>
  <app-live-help-widget *ngIf="showLiveHelp"></app-live-help-widget>
  <section class="body container-fluid p-0">
    <ng-container #otpContainer></ng-container>
    <router-outlet></router-outlet>
  </section>
  <app-tab-sync-dialog></app-tab-sync-dialog>

  <div class="footer">
    <div class="footer_contents">
      <div *ngIf="connectionChanged" class="connection-status" [ngClass]="{
        'disconnected': noInternetConnection,
        'poor': !noInternetConnection && poorNetwork,
        'connected': !noInternetConnection && !poorNetwork
      }">
        <div class="connection-bars">
          <div class="bars-wrapper" *ngIf="!noInternetConnection && networkInfoApiSupported">
            <div *ngFor="let bar of [1, 2, 3]; let i = index" class="bar" [class.active]="i + 1 <= connectionBars">
            </div>
          </div>
          <div class="no-connection-bars" *ngIf="noInternetConnection">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 13.5C3 12.1193 4.11929 11 5.5 11V11C6.88071 11 8 12.1193 8 13.5V21H3V13.5Z" fill="#D0D5DD" />
              <path d="M10 8.5C10 7.11929 11.1193 6 12.5 6V6C13.8807 6 15 7.11929 15 8.5V21H10V8.5Z" fill="#D0D5DD" />
              <path d="M17 3.5C17 2.11929 18.1193 1 19.5 1V1C20.8807 1 22 2.11929 22 3.5V21H17V3.5Z" fill="#D0D5DD" />
              <path d="M23.3555 1.35156L1.35547 23.3516" stroke="#667085" stroke-linecap="round" />
            </svg>
          </div>
        </div>
        <!-- disconnected -->
        <div class="status-container" *ngIf="noInternetConnection">
          <span><span>{{'connection.lost' | translate}}</span> </span>
        </div>
        <!-- poor -->
        <div class=" status-container" *ngIf="!noInternetConnection && poorNetwork ">
          <span><span>{{'connection.poor' | translate}}</span> </span>
        </div>
        <!-- connected -->
        <div class=" status-container" *ngIf="!noInternetConnection && !poorNetwork">
          <span><span>{{'connection.restored' | translate}}</span> </span>
        </div>
        <div class="close-bar">
          <span style="cursor: pointer;" (click)="connectionChanged = false">
            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.5413 8.45703L8.45801 20.5404M20.5413 20.5404L8.45801 8.45703" stroke="#FFFF" stroke-width="2"
                stroke-linecap="round" />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>